<style scoped>
.br-10 {
  border-radius: 10px;
}
.ellipsis {
  white-space: nowrap;
  width: 250px;
  text-overflow: ellipsis;
}
</style>

<template>
  <v-container fluid>
    <v-alert v-if="!hasLicenseAdminRole" id="error" :value="'Error'"
      class="br-10 dark font-weight-medium" type="error" dismissible>
      {{ 'No user access. Office use only.' | uppercase }}
    </v-alert>

    <v-flex v-if="hasLicenseAdminRole && hasSession">
      <v-card-title class="headline">Senarai Permohonan Lesen Berniaga</v-card-title>
      <v-card>
        <v-progress-linear :indeterminate="loading" v-if="loading"></v-progress-linear>
         <v-data-table
          :headers="headers"
          :items="list"
          hide-actions
        >
          <template slot="items" slot-scope="props">
            <td class="font-weight-bold">{{ props.item._id }}</td>
            <td class="font-weight-bold">{{ $t(props.item.status) || "-" }}</td>
            <td class="font-weight-bold">
              {{ props.item.applicant.name || "-" }}
              <br>
              {{ props.item.applicant.identity_no || "-" }}
            </td>
            <td class="font-weight-bold">
              {{ props.item.applicant.phone || "-" }}
              <br>
              {{ props.item.applicant.email || "-" }}
            </td>
            <td class="font-weight-bold">{{ props.item.timestamp | dateTime }}</td>
            <td  @click="$router.push(`/trading/preview/${props.item._id}`)">
              <v-btn icon class="mx-0">
                <v-icon color="primary">fa-search fa-lg</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-card>
    </v-flex>
  </v-container>
</template>

<script>
import vuex from 'vuex'

export default {
  beforeMount () {
    this.fetchList()
  },
  beforeDestroy () {
    this.resetData()
  },
  created: function () {
    this.$store.dispatch('auth/session')
  },
  computed: {
    ...vuex.mapState({
      headers: state => state.tradingList.headers,
      loading: state => state.tradingList.loading,
      list: state => state.tradingList.list
    }),
    ...vuex.mapGetters({
      hasSession: 'auth/hasSession',
      hasLicenseAdminRole: 'auth/hasLicenseAdminRole'
    })
  },
  methods: {
    ...vuex.mapActions({
      fetchList: 'tradingList/fetchList',
      resetData: 'tradingList/resetData'
    })
  }
}
</script>
